/* eslint-disable no-restricted-globals */
import React, { useEffect, useMemo } from 'react';

import { sumBy } from 'lodash';
import PropTypes from 'prop-types';

import TableHeaderCheckboxAll from '../../../../components/Table/CheckAll';
import { generateTableHead, countDecimalMax } from '../../helpers';

const TableHead = ({
  handleSelect,
  orders,
  values,
  setValues,
  onChangeCheck,
  config,
  access,
  accessMassActions,
  bulkActions,
}) => {
  useEffect(() => {
    setValues([]);
  }, [setValues]);

  const computedSelectedTotals = useMemo(() => {
    const selectedOrders = orders?.filter((order) => values?.includes(order.id));
    if (!selectedOrders?.length) return [];
    return [
      config?.fields?.charge && {
        label: 'Charge',
        value: sumBy(selectedOrders, (order) => (!isNaN(order?.charge) ? Number(order?.charge) : 0))?.toFixed(
          countDecimalMax(selectedOrders?.map((order) => order?.charge)),
        ),
      },
      config?.fields?.cost && {
        label: 'Cost',
        value: sumBy(selectedOrders, (order) => (!isNaN(order?.cost_formatted) ? Number(order?.cost_formatted) : 0))?.toFixed(
          countDecimalMax(selectedOrders?.map((order) => order?.cost_formatted)),
        ),
      },
      config?.fields?.charge
        && config?.fields?.cost && {
        label: 'Profit',
        value: sumBy(selectedOrders, (order) => (!isNaN(order?.profits) ? Number(order?.profits) : 0))?.toFixed(
          countDecimalMax(selectedOrders?.map((order) => order?.profits)),
        ),
      },
      config?.fields?.count && {
        label: 'Quantity',
        value: sumBy(selectedOrders, (order) => (!isNaN(order?.count) ? Number(order?.count) : 0)),
      },
      {
        label: 'Remains',
        value: sumBy(selectedOrders, (order) => (!isNaN(order?.remains) ? Number(order?.remains) : 0)),
      },
    ]?.filter(Boolean);
  }, [config.fields, orders, values]);

  return (
    <thead>
      <tr>
        {generateTableHead(config?.fields).map((item, index) => {
          if (item.access === false) {
            return null;
          }

          switch (item.type) {
          case 'all':
            return (
              <TableHeaderCheckboxAll
                key={index}
                handleSelect={(key) => handleSelect(key, null, 'mass')}
                transKey="Table.MassCounterOrders"
                transValue="{{count}} orders selected"
                values={values}
                onChangeCheck={onChangeCheck}
                accessMassActions={accessMassActions}
                submenuStatuses={bulkActions?.change_status}
                configAccess={{
                  ...access,
                  see_order_id: true,
                  see_link: true,
                  see_all_data: true,
                  see_all_data_with_provider: access?.see_provider,
                }}
                pullRight={false}
                tdClass="table__orders-checker"
                totals={computedSelectedTotals}
              />
            );

          case 'user':
            if (access?.see_user === false) {
              return null;
            }
            return <th key={index}>{item.value}</th>;

          case 'charge':
            if (!access?.see_charge) {
              return null;
            }

            return <th key={index}>{item.value}</th>;

          case 'id':
            return (
              <th key={index} className="table__orders-id">
                {item.value}
              </th>
            );

          case 'link':
            return (
              <th key={index} className="table__orders-link">
                {item.value}
              </th>
            );

          case 'start_count':
            return (
              <th key={index} className="table__orders-start_count">
                {item.value}
              </th>
            );

          case 'quantity':
            return (
              <th key={index} className="table__orders-quantity">
                {item.value}
              </th>
            );

          case 'status':
            return (
              <th key={index} className="table__orders-status">
                {item.value}
              </th>
            );

          case 'remains':
            return (
              <th key={index} className="table__orders-remains">
                {item.value}
              </th>
            );

          case 'created':
            return (
              <th key={index} className="table__orders-date">
                {item.value}
              </th>
            );

          case 'actions':
            return (
              <th key={index} className="table__orders-actions">
                {item.value}
              </th>
            );

          case false:
            return null;

          default:
            return <th key={index}>{item.value}</th>;
          }
        })}
      </tr>
    </thead>
  );
};

TableHead.propTypes = {
  handleSelect: PropTypes.func,
  orders: PropTypes.array,
  values: PropTypes.array,
  setValues: PropTypes.func,
  onChangeCheck: PropTypes.func,
  config: PropTypes.object,
  access: PropTypes.object,
  accessMassActions: PropTypes.array,
  bulkActions: PropTypes.object,
};

export default TableHead;
